<script lang="ts">
    import type {RecordHolding} from 'typings/portaro.be.types';
    import {getPageContext} from 'shared/layouts/page-context';
    import {onDestroy} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import KpGenericTopbar from 'shared/components/kp-generic-topbar/KpGenericTopbar.svelte';
    import SutorFondChip from './components/SutorFondChip.svelte';
    import KpVerticalSeparator from 'shared/ui-widgets/separator/KpVerticalSeparator.svelte';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';
    import SutorDocumentDetailSettingsPopover from './components/SutorDocumentDetailSettingsPopover.svelte';
    import type {
        DocumentDetailReactivePageData,
        DocumentDetailStaticPageData
    } from '../../../record/kp-document-detail-page/types';

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const model = pageContext.staticData.model;

    let recordHoldings: RecordHolding[];
    const reactiveDataUnsubscribe = pageContext.reactiveData.subscribe((data) => recordHoldings = data.recordHoldings);
    onDestroy(reactiveDataUnsubscribe);

    $: filteredHoldings = (recordHoldings ?? []).filter((holding) => !exists(holding.discardionEventId) && !exists(holding.deletionEventId));
</script>

<KpGenericTopbar height="var(--sutor-topbar-height)" gap="24px">
    <div class="title-container">
        <SutorFondChip chipSize="sm" fondId="{model.record.fond.id}">{model.record.fond.text}</SutorFondChip>
        <span class="record-name">{model.record.name}</span>
    </div>

    {#if filteredHoldings.length > 0}
        <KpVerticalSeparator height="20px"/>

        <div class="holdings-container">
            {#each filteredHoldings as recordHolding(recordHolding.id)}
                <KpChipTag chipSize="xs">
                    {pipe(recordHolding.department, loc())}
                </KpChipTag>
            {/each}
        </div>
    {/if}

    <div class="full-width-spacer"></div>

    <SutorDocumentDetailSettingsPopover/>
</KpGenericTopbar>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .title-container {
        display: flex;
        align-items: center;
        gap: @spacing-m;
    }

    .holdings-container {
        display: flex;
        align-items: center;
        gap: @spacing-s;
    }
</style>